import React from 'react';
import '../App.css';
import {HeaderProvider} from "../header/headerContext";
import {BrowserRouter} from "react-router";
import {Box} from "@mui/material";
import {FirebaseProvider} from "../firebase/firebaseContext";
import {Header} from "../header/Header";
import {Content} from "./Content";
import {AppRoutes} from "./AppRoutes";
import {Menu} from "../menu/Menu";
import {Firebase} from '../firebase/Firebase';
import {Helmet} from "react-helmet";
import {FileProvider} from "../file/fileContext";
import {Footer} from "../footer/Footer";
import {ScrollToTop} from "./ScrollToTop";

const App = () => {
    return (
        <BrowserRouter>
            <ScrollToTop/>
            <Helmet>
                <title>Kurs i bekymringsmestring</title>
            </Helmet>

            <FirebaseProvider>
                <Firebase>
                    <HeaderProvider>
                        <Box sx={{
                            display: "flex",
                            flexDirection: "column",
                            backgroundColor: "background.default",
                            minHeight: "100vh",
                            width: "100%",
                            maxWidth: "100%",
                            overflowX: "clip",
                        }}>
                            <Header/>
                            <Menu/>
                            <FileProvider>
                                <Content>
                                    <AppRoutes/>
                                </Content>
                            </FileProvider>
                            <Footer/>
                        </Box>
                    </HeaderProvider>
                </Firebase>
            </FirebaseProvider>
        </BrowserRouter>
    );
};

export default App;
